import React, { useEffect, useState } from 'react';
import Button from '../ui/Button.jsx';
import { Card, CardContent } from '../ui/Card.jsx';
import QuestionnaireInfoStep, { QUESTIONNAIRE_INFO_STEP_IDS } from './QuestionnaireInfoStep.jsx';

export default function QuestionnaireIntroOverlay({ open, onClose }) {
  const [step, setStep] = useState(0);
  const currentStepId = step === 0
    ? QUESTIONNAIRE_INFO_STEP_IDS.purpose
    : QUESTIONNAIRE_INFO_STEP_IDS.questionnaire;

  useEffect(() => {
    if (open) setStep(0);
  }, [open]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50">
      <div
        className="absolute inset-0 bg-[#1f2649]/35 backdrop-blur-sm"
        onClick={onClose}
        aria-hidden="true"
      />

      <div className="absolute inset-0 flex items-center justify-center p-4">
        <div className="w-full max-w-2xl">
          <Card className="shadow-ptcm-soft">
            <CardContent className="space-y-6 max-h-[75vh] overflow-auto">
              <QuestionnaireInfoStep stepId={currentStepId} />

              <div className="flex flex-col sm:flex-row gap-2 sm:justify-end">
                {step === 0 ? (
                  <Button onClick={() => setStep(1)}>Suivant</Button>
                ) : (
                  <>
                    <Button variant="outline" onClick={() => setStep(0)}>Précédent</Button>
                    <Button onClick={onClose}>J’ai compris</Button>
                  </>
                )}
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
}

